
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"13","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11.667 14H4.333V4.667h7.334V14zm0-10.667H4.333A1.333 1.333 0 003 4.667V14a1.333 1.333 0 001.333 1.333h7.334A1.333 1.333 0 0013 14V4.667a1.334 1.334 0 00-1.333-1.334zm-2-2.666h-8A1.333 1.333 0 00.333 2v9.333h1.334V2h8V.667z","fill":"#6D6D6D"}})])
          )
        }
      }
    